export const confirmModalContainer = {
  position: 'relative',
  // left: '50%',
  // top: '50%',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '497px',
  width: 'calc(100% - 16px)',
  // transform: 'translate(-50%, -50%)',
  background: 'var(--white)',
  borderRadius: '20px',
  padding: '40px',
  textAlign: 'center',
  boxShadow: '0px 0px 20px 0px #0000000D',
  height: 'calc(100% - 16px)',
  maxHeight: 'fit-content',
  overflow: 'auto',

  '.close-icon': {
    position: 'absolute',
    right: '16px',
    top: '16px',
    cursor: 'pointer',
  },

  '.modal-img': {
    marginBottom: '32px',
    maxWidth: '100%',
  },

  '@media (max-width: 768px)': {
    padding: '40px 20px',
  },
};

export const buttonGroup = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  margin: '44px auto 0',
};

export const cancelBtn = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px 20px',
  fontWeight: '500',
  fontSize: '18px',
  color: 'var(--grey400)',
};

export const confirmBtn = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px 20px',
  fontWeight: '500',
  fontSize: '18px',
  borderRadius: '20px',
  color: 'var(--white)',
  background: 'var(--primary)',

  '&.danger-btn': {
    background: 'var(--darkRed)',
    color: 'var(--white)',
  },
};

export const backDropOverlay = {
  backgroundColor: '#C9C8C84D',
  backdropFilter: 'blur(3px)',
};
